import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.get-approved-expense-item-count.UseApprovedExpenseItemCountPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to fetch the approved expense item count',
  },
})
